























































































































































































































































































































































import { Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { vxm } from '@/store.vuex';
import Avatar from 'vue-avatar';

@Component({
  name: 'ChatFrame',
  components: {
    Avatar,
  },
})
export default class ChatFrame extends Vue {
  @Prop() chattingData;
  @Prop() isCandidateConversationAvailable;
  private participantData: object = {};
  private smsValue: string = '';
  private previousDate: number = 0;

  get ChatFrameHeader() {
    if (
      this.chattingData.conversation.context === '01' ||
      this.chattingData.conversation.context === '02'
    ) {
      return null;
    }
    return;
  }

  get userId() {
    return vxm.users.myUserProfile.userId;
  }

  participantName(firstName: String, lastName: String) {
    let fullName = firstName + ' ' + lastName;
    return fullName;
  }

  async sendMessage(text) {
    this.smsValue = '';
    if (
      text &&
      text !== '' &&
      this.chattingData &&
      this.chattingData.conversation
    ) {
      let destinationId;
      for (let i = 0; i < this.chattingData.participants.length; i++) {
        if (this.chattingData.participants[i].participantId !== this.userId) {
          destinationId = this.chattingData.participants[
            i
          ].participantId.toString();
          break;
        }
      }
      try {
        let respData = await vxm.jobs.sendMessage({
          conversationMessage: {
            origin: this.userId,
            messageType: this.chattingData.conversation.conversationType,
            messageText: text,
            destination: destinationId,
          },
          conversation: {
            conversationGUID: this.chattingData.conversation.conversationGUID,
            initiatedBy: this.chattingData.conversation.initiatedBy,
            claimedBy: null,
            context: this.chattingData.conversation.context,
            contextId: this.chattingData.conversation.contextId,
            participants: [destinationId],
            topic: null,
            lastUpdatedDTTM: this.chattingData.conversation.lastUpdatedDTTM,
            conversationMessages: null,
            unreadMessages: null,
            conversationStatus: this.chattingData.conversation
              .conversationStatus,
            lastConversationMessage: this.chattingData.conversation
              .lastConversationMessage,
            companyCode: 'TCQA',
            conversationType: this.chattingData.conversation.conversationType,
            status: this.chattingData.conversation.status,
            conversationMessagesCount: this.chattingData.conversation
              .conversationMessagesCount,
          },
          isAdmin: true,
          originId: this.userId,
        });
        this.$emit('reload-chating-data', true);
      } catch (error) {
        console.log('Exception in sendMessage message : ', error);
      }
    } else {
      console.log('Empty String...');
    }
  }
  getDate(date) {
    console.log('This is date : ', date);
    var convertedDate = new Date(date);
    var todayDate = new Date();
    if (
      convertedDate.getDate() == todayDate.getDate() &&
      convertedDate.getMonth() == todayDate.getMonth() &&
      convertedDate.getFullYear() == todayDate.getFullYear()
    ) {
      return 'Today';
    }
    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    const weekday = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    return (
      weekday[convertedDate.getDay()] +
      ', ' +
      convertedDate.getDate() +
      ' ' +
      monthNames[convertedDate.getMonth()]
    );
  }

  getTime(dateIndttm) {
    var date = new Date(dateIndttm);
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var minutesStr = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutesStr + ' ' + ampm;
    return strTime;
  }

  isSameDateTime(date) {
    if (this.previousDate === 0) {
      this.previousDate = date;
      return true;
    }
    let newDate = new Date(date);
    let pastDate = new Date(this.previousDate);
    if (
      newDate.getDate() == pastDate.getDate() &&
      newDate.getMonth() == pastDate.getMonth() &&
      newDate.getFullYear() == pastDate.getFullYear()
    ) {
      return false;
    } else {
      this.previousDate = date;
      return true;
    }
  }

  get companyCode() {
    return vxm.users.getCompanyCode;
  }

  getCompanyImage(companyCode) {
    const COMPANY_LOGO_URL = vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    );
    const LOGO_FILE_SEPERATOR = '/';
    const LOGO_FILE = vxm.utility.companyLogoFile;
    const CompanyLogoUrl =
      COMPANY_LOGO_URL +
      LOGO_FILE_SEPERATOR +
      companyCode +
      LOGO_FILE_SEPERATOR +
      LOGO_FILE;
    return CompanyLogoUrl;
  }
}
